import { isEmpty } from "@swiggy-private/js-utils";
import { EMAIL_REGEX } from "@swiggy-private/checkout-core";

export function capitalizeFirstLetter(string = ""): string {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export const isValidEmailId = (value: string, maxLength: number): boolean => {
    if (isEmpty(value)) return true;
    if (value.length > maxLength) return false;
    return EMAIL_REGEX.test(value);
};
